var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImpresonTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 2.01188C19.2642 2.35385 18.474 2.58465 17.6432 2.68731C18.4902 2.15638 19.141 1.31554 19.448 0.313846C18.6547 0.804885 17.7769 1.16319 16.8423 1.35477C16.0934 0.521115 15.0269 0 13.846 0C11.5798 0 9.74369 1.921 9.74369 4.29119C9.74369 4.62727 9.77932 4.9555 9.84934 5.26935C6.43911 5.09019 3.41585 3.38169 1.3916 0.785269C1.03901 1.4195 0.836459 2.15638 0.836459 2.94296C0.836459 4.43242 1.56102 5.74535 2.66129 6.51558C1.98925 6.49269 1.35659 6.30046 0.803326 5.97877C0.802701 5.99642 0.802701 6.01538 0.802701 6.03238C0.802701 8.11227 2.2168 9.84692 4.09415 10.2412C3.75031 10.3386 3.38772 10.3916 3.01325 10.3916C2.74819 10.3916 2.49187 10.3648 2.24181 10.3151C2.76319 12.019 4.27919 13.26 6.07402 13.2953C4.67054 14.4461 2.90135 15.1333 0.978995 15.1333C0.647662 15.1333 0.320705 15.113 0 15.0731C1.81545 16.2893 3.97224 17 6.2897 17C13.8366 17 17.9645 10.4609 17.9645 4.78942C17.9645 4.60373 17.9595 4.41804 17.952 4.23365C18.7541 3.62885 19.4492 2.87365 20 2.01188Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpresonTwitter);
export default __webpack_public_path__ + "static/media/impreson_twitter.f3d0e8362b86224123ff1cdb3e7cca05.svg";
export { ForwardRef as ReactComponent };